import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import GlobalContext from '../context/GlobalContext.js';
import navTabs from '../config/navConfig.js';

export default function BottomTabBar({ unreadCount, agreementId }) {
    const { settings, theme, themeCSS } = useContext(GlobalContext);
    const location = useLocation();
    const primaryColor = settings?.primary_hex_colour || '#813468';

    // Filter tabs by feature flags
    const visibleTabs = navTabs.filter(tab => {
        if (!tab.settingsKey) return true;
        return settings && settings[tab.settingsKey] === 1;
    });

    // Determine active tab from current path
    const activeTab = (() => {
        const path = location.pathname;
        if (path === '/' || path === '/home') return 'home';
        if (path.startsWith('/repairs') || path.startsWith('/appointments')) return 'repairs';
        if (path.startsWith('/requests')) return 'tasks';
        if (path.startsWith('/documents')) return 'documents';
        if (path.startsWith('/messages')) return 'messages';
        return 'home';
    })();

    // Hide on sub-pages where the tab bar would be in the way
    const hiddenPaths = ['/extendedverification', '/allpaypayment'];
    const shouldHide = hiddenPaths.some(p => location.pathname.startsWith(p));
    if (shouldHide) return null;

    function navigateTo(tab) {
        let path = tab.path;
        if (tab.key === 'documents' && agreementId) {
            path = `/documents/${agreementId}`;
        } else if (tab.key === 'documents') {
            return; // no agreement loaded yet
        }
        if (path) {
            window.location.href = path;
        }
    }

    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 flex justify-center pb-5 px-5 pointer-events-none">
            <div
                className={`pointer-events-auto flex items-center rounded-full shadow-lg px-2 py-2 ${
                    theme === 'dark' ? 'bg-slate-800' : theme === 'highContrast' ? 'bg-yellow-300 border-2 border-black' : 'bg-white'
                }`}
                style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
            >
                {visibleTabs.map((tab) => {
                    const isActive = activeTab === tab.key;
                    const Icon = tab.icon;
                    return (
                        <button
                            key={tab.key}
                            onClick={() => navigateTo(tab)}
                            className="relative flex flex-col items-center justify-center px-4 py-1.5 transition-colors"
                            style={{ minWidth: 52 }}
                        >
                            {/* Active indicator dot — above the icon */}
                            <div
                                className={`w-1.5 h-1.5 rounded-full mb-1 transition-opacity duration-300 ${isActive ? 'opacity-100' : 'opacity-0'}`}
                                style={{ backgroundColor: theme === 'highContrast' ? '#000000' : primaryColor }}
                            />
                            <div className="relative">
                                <Icon
                                    size={24}
                                    color={isActive
                                        ? (theme === 'highContrast' ? '#000000' : primaryColor)
                                        : (theme === 'dark' ? '#94A3B8' : theme === 'highContrast' ? '#4B5563' : '#8E8E93')
                                    }
                                    strokeWidth={isActive ? 2.5 : 1.5}
                                />
                                {/* Unread badge on Messages */}
                                {tab.key === 'messages' && unreadCount > 0 && (
                                    <span className="absolute -top-1 -right-2 min-w-[16px] h-4 flex items-center justify-center rounded-full text-[10px] font-bold text-white px-1 bg-red-500">
                                        {unreadCount}
                                    </span>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
